// Contact details – single source for mailto links and display
export const CONTACT_EMAIL = 'contact@internettvservice.com';
export const CONTACT_PHONE = '+1 (888) 880-2585';

/**
 * Build a mailto link so the user can send the form content via their email client.
 * Use when API submit fails or as fallback.
 */
export function getContactMailtoLink(formData) {
  const subject = encodeURIComponent('Contact form: ' + (formData.service || 'Inquiry'));
  const bodyParts = [
    formData.name && `Name: ${formData.name}`,
    formData.email && `Email: ${formData.email}`,
    formData.phone && `Phone: ${formData.phone}`,
    formData.address && `Address: ${formData.address}`,
    formData.service && `Service: ${formData.service}`,
    formData.message && `Message:\n${formData.message}`,
  ].filter(Boolean);
  const body = encodeURIComponent(bodyParts.join('\n'));
  return `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
}
